import {
  APPROVE_GENERAL_ORDER_RESULT,
  FETCH_CLIENT_RESULT,
  FETCH_ENTERED_RESULT_TEST_TYPE,
  FETCH_GO_ENTERED_RESULT_TEST_TYPE,
  FETCH_ORGANISM,
  FETCH_PH_ENTERED_RESULT_TEST_TYPE,
  FETCH_PH_VERIFIED_RESULT,
  FETCH_TB_ENTERED_RESULT_TEST_TYPE,
  FETCH_UNIQUE_ORGANISM,
  SET_CLIENT_RESULT_PAGINATION,
  SET_GO_RESULT_PAGINATION,
  SET_PH_RESULT_PAGINATION,
  SET_PH_VERIFIED_RESULT_PAGINATION,
} from "constants/ActionTypes";
import { pageSizeOptions } from "utils/Constant";

const INITIAL_STATE = {
  data: [],
  loading: false,
  resultList: [],
  approveResultList: [],
  enteredResultList: [],
  enteredGOResultList: [],
  enteredPHResultList: [],
  enteredTBResultList: [],
  verifiedPHResultList: [],
  clientResultList: [],
  uniqueOrganisms: [],
  phOrganisms: [],
  pagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  clientPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  phResultPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  phVerifiedResultPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
};

const ResultReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APPROVE_GENERAL_ORDER_RESULT: {
      let updatedList = state.approveResultList;
      updatedList = [action.payload, ...updatedList];

      return {
        ...state,
        approveResultList: updatedList,
      };
    }
    case FETCH_ENTERED_RESULT_TEST_TYPE: {
      return {
        ...state,
        enteredResultList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_GO_ENTERED_RESULT_TEST_TYPE: {
      return {
        ...state,
        goSampleTestTypeList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_PH_ENTERED_RESULT_TEST_TYPE: {
      return {
        ...state,
        enteredPHResultList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_PH_VERIFIED_RESULT: {
      return {
        ...state,
        verifiedPHResultList: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || action.payload?.data || [],
      };
    }
    case FETCH_TB_ENTERED_RESULT_TEST_TYPE: {
      return {
        ...state,
        enteredTBResultList: action.payload,
      };
    }
    case FETCH_CLIENT_RESULT: {
      return {
        ...state,
        clientResultList: action.payload,
      };
    }
    case FETCH_UNIQUE_ORGANISM: {
      return {
        ...state,
        uniqueOrganisms: action.payload,
      };
    }
    case FETCH_ORGANISM: {
      return {
        ...state,
        phOrganisms: action.payload,
      };
    }
    case SET_GO_RESULT_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }
    case SET_CLIENT_RESULT_PAGINATION: {
      return {
        ...state,
        clientPagination: action.payload,
      };
    }
    case SET_PH_RESULT_PAGINATION: {
      return {
        ...state,
        phResultPagination: action.payload,
      };
    }
    case SET_PH_VERIFIED_RESULT_PAGINATION: {
      return {
        ...state,
        phVerifiedResultPagination: action.payload,
      };
    }

    default:
      return state;
  }
};

export default ResultReducer;
